export const SEND_MAIL = "SEND_MAIL";
export const SEND_MAIL_SUCCESS = "SEND_MAIL_SUCCESS";
export const SEND_MAIL_ERROR = "SEND_MAIL_ERROR";
